import { Component, OnInit, OnDestroy, Input, inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from "@angular/router";
import { ROUTE_PATHS } from '../route-paths';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Component({
    selector: 'app-nursing-audit',
    templateUrl: './nursing-audit.component.html',
    styleUrls: ['./nursing-audit.component.css'],
    standalone: false
})
export class NursingAuditComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  authService = inject(AuthService);

  //MV2-518
  appHeaderTitle = "Risk Assessment";
  @Input() deId = false;
  dissableDeIdSwitch = false;
  private readonly destroy$ = new Subject<void>();

  constructor() {
    const router = this.router;
              
    router.events.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (router.url == `/${ROUTE_PATHS.riskAssessment}/overrides`) {
        this.appHeaderTitle = "Audit Configuration"
      }
      else {
        this.appHeaderTitle = "Risk Assessment"
      }
    });
  }

  ngOnInit(): void {
    const deIdState = this.authService.getDeIdState();
    this.deId = deIdState.value;
    this.dissableDeIdSwitch = deIdState.disabled;

    this.route.data.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.deId = this.authService.isDemoUser() ? true : x.deId;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  updateDeIdMode(value: boolean) {
    if (!this.authService.isDemoUser()) {
      this.deId = value;
      this.authService.setDeIdentified(value);
    }
  }
}
